import gql from 'graphql-tag';

import { homeTaskFragment } from '~/shared/graphql-queries/home-tasks/index';

export default gql`
  mutation updateByIdHomeTaskMutation(
    $_id: MongoID!
    $record: UpdateByIdHomeTaskInput!
  ) {
    updateByIdHomeTaskMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...HomeTaskFragment
      }
      message
      title
    }
  }
  ${homeTaskFragment}
`;
